import type { BizIconProps } from './base';
import BizIconSvg from './base';

/** IconHeadset — 智能坐席辅助：话务耳机（耳罩 + 头梁 + 麦克风） */
export default function IconHeadset(props: BizIconProps) {
  return (
    <BizIconSvg {...props}>
      <path d="M2.67 8.67v-.67a5.33 5.33 0 0 1 10.67 0v.67" />
      <rect x="1.33" y="8.67" width="3.33" height="4.67" rx="1.33" />
      <rect x="11.33" y="8.67" width="3.33" height="4.67" rx="1.33" />
      <path d="M12.67 11.67a2 2 0 0 1-2 2h-1" />
      <path d="M9.67 13.67v.67" />
    </BizIconSvg>
  );
}
